module.exports = {
      id: "arcade-usage",
      viewBox: "0 0 19.915 20.731",
      url: "/" + "sprite-4add775381efce29ef76f223dff77c00.svg#arcade",
      toString: function () {
        return this.url;
      }
    }